import script from "./DashSection.vue?vue&type=script&setup=true&lang=js"
export * from "./DashSection.vue?vue&type=script&setup=true&lang=js"

import "./DashSection.vue?vue&type=style&index=0&id=33517fc0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-33517fc0"]])

export default __exports__